import { render, staticRenderFns } from "./HalfModal.vue?vue&type=template&id=16bb9fb6&"
import script from "./HalfModal.vue?vue&type=script&lang=ts&"
export * from "./HalfModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports